import React, {Fragment, useState} from 'react';
import MobileHeader from './MobileHeader.js';
import DesktopHeader from './DesktopHeader.js';

const Header = props => {

  const [showOnMobile, setShowOnMobile] = useState(false);

  const toggleMenu = () => {
    setShowOnMobile(!showOnMobile);
  }

  return (
    <Fragment>
      <MobileHeader handleClick={toggleMenu}/>
      <DesktopHeader showOnMobile={showOnMobile} handleClick={toggleMenu}/>
    </Fragment>
  );
}

export default Header;